import { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import * as stylex from '@stylexjs/stylex';
import '@/common/tokens.stylex';
import { colors } from '@/common/tokens.stylex';
const ping = "x1ln90do-B";
export function GalleryPlaceholder() {
  const ref = useRef<HTMLBodyElement | null>(null);
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    ref.current = document.querySelector('body');
    setMounted(true);
  }, []);
  return mounted ? createPortal(<div className="x1pgnn3v x1jafw1f xixxii4 x1ey2m1c x13vifvy xu96u03 x3m8u43 x78zum5 x6s0dn4 xl56j7k">
          <div className="x10hpsqq x1td3qas x10w6t97 xffbo4n x6b8e1p x1q3qbx4 x76wil1 xa4qsjk" />
        </div>, ref.current) : null;
}